import React, { useState, useEffect } from 'react';

// MantenidosPanel: clientes con casos de administración MANTENIDOS o ABIERTOS.
// Expiran solos a los 7 días sin respuesta del admin.
const MantenidosPanel = () => {
  const [casos, setCasos] = useState([]);
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem('token') || '';
  const auth = { headers: { Authorization: 'Bearer ' + token } };

  const cargar = async () => {
    try {
      const res = await fetch('/api/casosadmin', { headers: { Authorization: 'Bearer ' + token } });
      const data = await res.json();
      setCasos(data.casos || []);
    } catch (e) {
      setCasos([]);
    }
    setLoading(false);
  };

  useEffect(() => {
    cargar();
    const t = setInterval(cargar, 30000);
    return () => clearInterval(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const quitar = async (phone) => {
    await fetch('/api/casosadmin/' + phone, { method: 'DELETE', headers: auth });
    cargar();
  };

  const cerrar = async (phone) => {
    await fetch('/api/casosadmin/cerrar', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token },
      body: JSON.stringify({ phoneNumber: phone }),
    });
    cargar();
  };

  const abrirChat = (caso) => {
    const id = String(caso.id_cliente || caso.phoneNumber || '').replace(/[^0-9]/g, '');
    window.location.href = id ? '/' + id : '/';
  };

  return (
    <div style={{ padding: '20px', color: '#e2e8f0', minHeight: '100vh', background: '#0f172a' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '15px', marginBottom: '18px' }}>
        <button
          onClick={() => { window.location.href = '/'; }}
          style={{ background: '#334155', color: 'white', border: 'none', borderRadius: '8px', padding: '8px 14px', cursor: 'pointer' }}
        >
          ← Volver
        </button>
        <h2 style={{ margin: 0 }}>👥 Clientes Mantenidos</h2>
        <span style={{ background: '#6f42c1', borderRadius: '12px', padding: '2px 10px', fontSize: '0.9rem' }}>
          {casos.length}
        </span>
      </div>
      <p style={{ color: '#94a3b8', marginTop: 0 }}>
        Casos de administración activos. Se quitan solos a los 7 días sin respuesta.
      </p>
      {loading ? (
        <p>Cargando...</p>
      ) : casos.length === 0 ? (
        <p style={{ color: '#64748b' }}>No hay clientes mantenidos ni casos abiertos.</p>
      ) : (
        <div style={{ display: 'grid', gap: '12px' }}>
          {casos.map((c) => (
            <div
              key={String(c.phoneNumber) + String(c.createdAt)}
              style={{
                background: '#1e293b', borderRadius: '12px', padding: '14px 18px',
                display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '12px',
                borderLeft: c.estado === 'MANTENIDO' ? '4px solid #0d6efd' : '4px solid #fd7e14',
              }}
            >
              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: 700 }}>
                  {c.estado === 'MANTENIDO' ? '📌' : '🧾'} {c.nombre || c.phoneNumber}{' '}
                  <span style={{ color: '#94a3b8', fontWeight: 400 }}>({c.phoneNumber})</span>
                </div>
                <div style={{ color: '#94a3b8', fontSize: '0.9rem', marginTop: '4px' }}>
                  {c.motivo || 'Sin detalle'}
                </div>
                <div style={{ color: '#64748b', fontSize: '0.8rem', marginTop: '4px' }}>
                  {c.estado} · desde {c.createdAt ? new Date(c.createdAt).toLocaleString() : '?'}
                  {c.ticket ? ' · ticket técnico #' + c.ticket : ''}
                </div>
              </div>
              <div style={{ display: 'flex', gap: '8px' }}>
                <button
                  onClick={() => abrirChat(c)}
                  style={{ background: '#0d6efd', color: 'white', border: 'none', borderRadius: '8px', padding: '8px 12px', cursor: 'pointer' }}
                >
                  Abrir chat
                </button>
                <button
                  onClick={() => cerrar(c.phoneNumber)}
                  style={{ background: '#198754', color: 'white', border: 'none', borderRadius: '8px', padding: '8px 12px', cursor: 'pointer' }}
                >
                  Cerrar caso
                </button>
                <button
                  onClick={() => quitar(c.phoneNumber)}
                  style={{ background: '#dc3545', color: 'white', border: 'none', borderRadius: '8px', padding: '8px 12px', cursor: 'pointer' }}
                >
                  Quitar
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MantenidosPanel;
